import { impressionsConfig } from '../impressions';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const impressionsMVConfig = {
    ...impressionsConfig,
    name: 'kpi.facebook.impressions',
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
